import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";

const ViewOrderModal = ({ data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  // var result = data.find(item => item.id === id);

  const [activeTab, setActiveTab] = useState("1");

  const result = data;
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  const formattedDate = data
    ? `${new Date(data.created_at * 1000)
        .getDate()
        .toString()
        .padStart(2, "0")}-${(new Date(data.created_at * 1000).getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${new Date(data.created_at * 1000).getFullYear()}`
    : "";

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal">
          <h2 className="text-center font-bold text-lg">Order Details</h2>

          {/* Tab Content */}
          <div
            className="p-4"
            style={{
              maxHeight: "60vh",
              overflowY: "auto",
              scrollbarWidth: "thin",
            }}
          >
            {activeTab === "1" && (
              <div className="flow-root rounded-lg border-gray-100 py-3  ml-5 mb-5">
                <dl className="border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      ID
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.id}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Entity
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.entity}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Amount
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.amount}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Amount Paid
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.amount_paid}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Amount Due
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.amount_due}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Currency
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.currency}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Receipt
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.receipt}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Offer Id
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.offer_id}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Status
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.status}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Attempts
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.attempts}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Created At
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {formattedDate}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewOrderModal);
